<template>
  <div class="px-2 pt-4">
    <v-layout wrap>
      <v-spacer></v-spacer>
      <v-flex xs12 sm3 v-if="filterDate" class="pa-1">
        <div>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="Select date dine in"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="
                menu = false;
                $emit('onSelectDateTimeDineIn', date);
              "
            ></v-date-picker>
          </v-menu>
        </div>
      </v-flex>
      <v-flex xs12 sm3 class="pa-1">
        <div>
          <v-select
            label="Filter by Province"
            :items="provinceData"
            item-text="province_name_en"
            item-value="province_id"
            clearable
            v-model="filterByProvince"
          ></v-select>
        </div>
      </v-flex>
    </v-layout>
    <v-card flat style="border: 1px solid #333">
      <v-data-table
        :headers="headers"
        :items="filteredOrderList"
        :loading="fetching_order"
        :rows-per-page-items="[
          25,
          50,
          100,
          { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 },
        ]"
      >
        <template slot="items" slot-scope="props">
          <tr style="background-color: #eeeeee">
            <td class="text-xs-left">{{ props.item.order_code }}</td>
            <td class="text-xs-left">
              {{ props.item.order_customer_full_name }}
            </td>

            <td class="text-xs-center">
              <span
                style="
                  border-radius: 6px;
                  padding: 0px 10px;
                  color: white;
                  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
                  white-space: nowrap;
                  font-weight: bold;
                "
                :style="{
                  backgroundColor:
                    props.item.order_status == 1
                      ? '#2196f3'
                      : props.item.order_status == 2
                      ? 'orange'
                      : props.item.order_status == 3
                      ? '#4bb543'
                      : 'red',
                }"
                >{{
                  props.item.order_status == 1
                    ? "New Order"
                    : props.item.order_status == 2
                    ? "On Process"
                    : props.item.order_status == 3
                    ? "Complete"
                    : "Cancel"
                }}</span
              >
            </td>
            <td class="text-xs-center">
              {{
                props.item.order_net_price
                  ? parseFloat(props.item.order_net_price).toFixed(2)
                  : "0.00"
              }}
            </td>
            <td class="text-xs-center">
              <v-icon
                medium
                :color="
                  props.item.order_is_paymented != 1 ||
                  props.item.order_payment_type == 2 ||
                  props.item.order_payment_type == 5
                    ? 'green'
                    : 'red'
                "
                >{{
                  props.item.order_payment_type == 1
                    ? "attach_money"
                    : props.item.order_payment_type == 2
                    ? "credit_card"
                    : props.item.order_payment_type == 3
                    ? "phone_iphone"
                    : props.item.order_payment_type == 4
                    ? "currency_exchange"
                    : props.item.order_payment_type == 5
                    ? "corporate_fare"
                    : ""
                }}</v-icon
              >
            </td>

            <td class="text-xs-center">
              {{ moment(props.item.create_at).format("YYYY-MM-DD HH:mm น.") }}
            </td>
            <td class="text-xs-center">
              {{
                moment
                  .utc(props.item.order_booking_datetime)
                  .format("YYYY-MM-DD HH:mm น.")
              }}
            </td>

            <td class="justify-center layout px-0">
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  small
                  icon
                  @click="toDetail(props.item)"
                >
                  <v-icon small>{{
                    props.item.order_status == 2 || props.item.order_status == 3
                      ? "remove_red_eye"
                      : "edit"
                  }}</v-icon>
                </v-btn>
                <span>{{
                  props.item.order_status == 2 || props.item.order_status == 3
                    ? "View"
                    : "View/Edit"
                }}</span>
              </v-tooltip>
            </td>
          </tr>
          <tr>
            <td>
              <v-btn
                small
                depressed
                color="primary black--text"
                style="border-radius: 10px"
                >{{
                  showProvinceName(props.item.order_store.store_province_id)
                }}</v-btn
              >
            </td>
            <td colspan="3">
              <b>ชื่อร้าน:</b>
              <b style="color: grey">
                {{ props.item.order_store.store_name }}</b
              >
            </td>
            <td colspan="3" class="text-xs-left">
              <b>เบอร์โทรร้าน:</b>
              <b style="color: grey"> {{ props.item.order_store.store_tel }}</b>
            </td>
            <td></td>
          </tr>
        </template>

        <template slot="no-data"></template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import newOrderForm from "@/components/back-office/OrderOnline/NewOrderForm.vue";
import { mapState } from "vuex";
export default {
  props: {
    filterDate: {
      default() {
        return false;
      },
    },
    dateTimeDineIn: {
      default() {
        return null;
      },
    },
    orderList: {},
    fetching_order: {},
  },
  components: {
    newOrderForm,
  },
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    headers: [
      {
        text: "Order code",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Customer",
        value: "role",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "status",
        sortable: false,
      },
      {
        text: "Net price",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Payment",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Date time order",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Date time dine in",
        align: "center",
        value: "role",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "role",
        sortable: false,
      },
    ],
    filterByProvince: undefined,
  }),
  created() {
    if (this.filterDate == true) this.date = this.dateTimeDineIn;
  },
  computed: {
    ...mapState({
      provinceData: (state) => state.fetchProvinceBack.provinceData,
    }),
    filteredOrderList() {
      return this.orderList.filter(
        (val) =>
          !this.filterByProvince ||
          (val.order_store &&
            val.order_store.store_province_id == this.filterByProvince)
      );
    },
  },
  methods: {
    toDetail(item) {
      if (item.order_status == 3) {
        this.$router.push({
          name: "dineinOrderDetailComplete",
          params: { order_id: item.order_id },
        });
      } else if (item.order_status == 4) {
        this.$router.push({
          name: "dineinOrderDetailCancel",
          params: { order_id: item.order_id },
        });
      } else if (item.order_status == 2) {
        this.$router.push({
          name: "dineinOrderDetailOnProcess",
          params: { order_id: item.order_id },
        });
      } else {
        this.$router.push({
          name: "dineinOrderDetailNewOrder",
          params: { order_id: item.order_id },
        });
      }
    },
    showProvinceName(province_id) {
      try {
        let provinceItem = this.provinceData.find(
          (val) => val.province_id == province_id
        );
        return provinceItem.province_name_en;
      } catch (e) {
        return "not found province";
      }
    },
  },
};
</script>
<style>
.tab-color {
  background-color: black;
  border-radius: 9px 9px 0px 0px;
  font-weight: 700;
}
</style>
